<div class="feedback-row">
  @if (feedbackOptions().includes('favourite')) {
    <button
      contextButton
      appButton
      name="toggle-like"
      location="advanced-mode"
      [appTooltip]="asset().is_liked ? 'Unfavorite' : 'Favorite'"
      [color]="asset().is_liked ? 'warn' : 'grey-60a40'"
      shape="round"
      [iconButton]="true"
      height="0"
      (click)="toggleAssetLike.emit(); stopPropagation($event)"
    >
      @if (is_liked()) {
        <app-svg src="/assets/icons/heart-filled.svg" size="0"> </app-svg>
      } @else {
        <app-svg src="/assets/icons/heart-empty.svg" size="0"> </app-svg>
      }
    </button>

    <app-favorite-button [asset]="asset()" [disabled]="false"></app-favorite-button>
  }
  @if (feedbackOptions()?.includes('status')) {
    <app-asset-status-button
      [gallery]="gallery()"
      [asset]="asset()"
      [location]="'advanced-mode'"
      [defaultColor]="'grey-60a40'"
      [small]="true"
      [advancedMode]="true"
      [displayOnly]="!gallery()"
      (onSelectStatus)="updateAssetStatus.emit($event)"
      (click)="stopPropagation($event)"
    ></app-asset-status-button>
  }
  @if (feedbackOptions().includes('color_label')) {
    <app-context-menu
      [options]="{ noSpacing: true, width: '240px' }"
      #menu
      contextHoverIdentifier="asset-{{ asset().id }}"
      appTooltip="Add a Color Label"
      [class.hidden]="asset().color_label"
    >
      <button
        appButton
        name="asset-color-label-dropdown"
        location="advanced-mode"
        [color]="(asset().color_label | colorLabelColor: false) || 'grey-60a40'"
        [iconButton]="true"
        height="0"
        shape="round"
        contextButton
      >
        <app-svg src="/assets/icons/color-label-filled.svg" size="0"></app-svg>
      </button>
      <div contextContent>
        <div class="button-menu">
          <app-color-label-context
            [currentColorLabel]="asset().color_label"
            location="advanced-mode"
            [colorLabels]="colorLabels()"
            (updateColorLabel)="updateAssetColorLabel.emit($event); menu.close()"
            (click)="stopPropagation($event)"
          ></app-color-label-context>
        </div>
      </div>
    </app-context-menu>
  }
</div>
